<template>
    <div class="menu">
        <el-menu :default-active=activeMenu class="el-menu-vertical-demo" :unique-opened=uniqueOpened @open="handleOpen"
            @close="handleClose" @select="choosePage" background-color="#545c64" text-color="#fff" :collapse=collapse
            :collapse-transition=collapseTransition active-text-color="#ffd04b">
            <template v-for="item in menuList">
                <template v-if="item.list">
                    <el-submenu :index="item.id + ''" :key="item.route">
                        <template slot="title">
                            <i v-if="item.icon" :class="item.icon"></i>
                            {{ item.name }}</template>
                        <el-menu-item v-for="item1 in item.list" :key="item1.route" :index="item1.route + ''">
                            <i v-if="item1.icon" :class="item1.icon"></i>
                            {{ item1.name }}
                        </el-menu-item>
                    </el-submenu>
                </template>
                <template v-else>
                    <el-menu-item :index="item.route + ''" :key="item.route">
                        <i v-if="item.icon" :class="item.icon"></i>
                        <span slot="title">{{ item.name }}</span>
                    </el-menu-item>
                </template>
            </template>

        </el-menu>
    </div>
</template>

<script>

export default {
    data() {
        return {
            collapseTransition: false,
            collapse: false,
            uniqueOpened: true,
            // activeMenu: "index",
            menuList: []
        }
    },
    computed: {
        activeMenu() {
            return this.$store.state.activeMenu
        },
    },
    watch: {
        activeMenu(newVal, oldVal) {
            console.log(newVal)
        }
    },
    mounted() {
        this.get();
        this.listenPage();
        window.addEventListener('beforeunload', this.listenPage)
    },
    methods: {
        get() {
            let data = {
            }
            this.$get(api + "/main/getMenu", data).then(response => {
                let res = response.data;
                // console.log(response)
                if (res.code == 0) {
                    this.menuList = res.data;
                }
            })
        },
        handleOpen(key, keyPath) {
            // console.log(key, keyPath);
        },
        handleClose(key, keyPath) {
            // console.log(key, keyPath);
        },
        choosePage(value) {
            this.$store.commit("setActiveMenu", value);
            this.$router.push({ path: value });
        },
        listenPage() {  //保存左侧菜单项
            sessionStorage.setItem("activeMenu", this.activeMenu);
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Menu.vue